import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@mui/material';
import PhoneComponents from './PhoneComponents';
import DesktopComponents from './DesktopComponents';

const DeviceWrapper = function DeviceWrapper({
  device = 'MOBILE',
  templateName = '',
  children = <div />,
}) {
  return (
    <Paper
      elevation={3}
      sx={{
        width: device === 'MOBILE' ? '70%' : '100%',
        height: '100%',
        borderRadius: device === 'MOBILE' ? '73px 73px 0px 0px' : '73px',
        padding: device === 'MOBILE' ? '0px 48px' : '0px 48px 48px',
        ...(device === 'DESKTOP'
          ? { display: 'flex', flexDirection: 'column' }
          : {}),
      }}
    >
      {device === 'MOBILE' ? (
        <PhoneComponents />
      ) : (
        <DesktopComponents title={templateName} />
      )}
      <div
        style={{
          width: '100%',
          height: '100%',
          borderRadius: device === 'MOBILE' ? '25px 25px 0px 0px' : '25px',
          padding: '16px',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        {children}
      </div>
    </Paper>
  );
};

DeviceWrapper.propTypes = {
  device: PropTypes.string,
  templateName: PropTypes.string,
  children: PropTypes.object,
};
export default DeviceWrapper;
